import { StorageAddonModal } from "../StorageAddonModal";
import { TTierKey } from "MVVM/Views/Pricing/Components/PricingCards/types";
import { EPriceTabView } from "MVVM/@types";

interface UnifiedUpgradeModalProps {
  featureName?: string;
  upgradeAction?: string;
  requiredTierKey?: TTierKey;
  analyticsSource: string;
  initialPlan?: string;
  initialBillingPeriod?: EPriceTabView;
  onClose: () => void;
}

export const UnifiedUpgradeModal = ({
  featureName,
  upgradeAction,
  requiredTierKey,
  analyticsSource,
  initialPlan,
  initialBillingPeriod,
  onClose,
}: UnifiedUpgradeModalProps) => {
  const paywallBanner =
    featureName && upgradeAction && requiredTierKey
      ? { featureName, upgradeAction, requiredTierKey }
      : undefined;

  return (
    <StorageAddonModal
      onClose={onClose}
      analyticsSource={analyticsSource}
      initialPlan={initialPlan ?? requiredTierKey}
      initialBillingPeriod={initialBillingPeriod}
      paywallBanner={paywallBanner}
    />
  );
};
